import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postFetch } from '@legacy/utils/fetcher';
import { GET_EMPLOYEE_AVAILABLE_COMPETENCES_KEY } from '@legacy/apis/employeeCompetencesAPI/constants';
import { IConvertedRow } from '../types';
import { COMPETENCES_URL_PATH, GET_COMPETENCES_KEY } from '../constants';

export const POST_COMPETENCES_MSW_STATUS_KEY = 'postCompetence';

export const POST_COMPETENCES_KEY = 'POST_COMPETENCES';

const postCompetence = ({ name, category, isActive }: IConvertedRow) =>
  postFetch({
    path: COMPETENCES_URL_PATH,
    key: POST_COMPETENCES_MSW_STATUS_KEY,
    body: JSON.stringify({
      Name: name,
      IsActive: isActive,
      GroupId: category,
    }),
  });

export const usePostCompetence = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: postCompetence,

    onSuccess: () => {
      qc.invalidateQueries({
        queryKey: [GET_COMPETENCES_KEY],
      });
      qc.invalidateQueries({
        queryKey: [GET_EMPLOYEE_AVAILABLE_COMPETENCES_KEY],
      });
    },
  });
};
